import React from 'react';

import { Button } from '../../../elements';
import { logout } from "../../auth/redux/authActions";
import { showError, showSuccess } from '../../../elements/Toasts/toastActions';
import { certificatesActions } from '../../../redux/reducers/certificates';
import FileInput from '../../../elements/FileInput/FileInput';
import ModalContainer from '../../../elements/ModalContainer/ModalContainer';
import strings from '../../../lang/lang';
import CertificateUploadFile from '../CertificateUploadFile';
import {ErrorStatus, isProdModeAvailable} from '../../../api/portal/portalApi';
import { useAppDispatch } from '../../../hooks/useRedux';

interface IUpload {
  closeModal: (params: any) => void;
}

function UploadCSR({ closeModal }: IUpload) {
  const dispatch = useAppDispatch();

  function handleCSRFile(file) {
    if (file && file[0]) {
      return new Promise((res, rej) => {
        dispatch(certificatesActions.uploadCSR({ attachments: { file: file[0] }, res, rej }));
      })
      .then(() => {
        showSuccess(strings.certificateContainer.text.successUploadCsr);
      })
      .catch(({ data, status }) => {
        if (data.message && !isProdModeAvailable(status, data.message)) {
          return;
        }
        if (401 === status) {
          logout();
        } else if (data.name && ErrorStatus.SESSION_OUTDATED === data.name) {
          closeModal({ name: 'show session outdata popup' });
        } else {
          showError(strings.formatString(strings.certificateContainer.errors.savingCsr, data.message));
        }
      })
      .finally(() => closeModal({}));
    }
  }

  return (
    <ModalContainer
      isOpen
      closeModalWindow={closeModal}
      title={strings.certificateContainer.text.uploadTitle}
      header={strings.certificateContainer.text.uploadDescription}
    >
      <FileInput
        accept=".csr"
        noDrag={false}
        onDrop={(file) => handleCSRFile(file)}
      >
        <CertificateUploadFile />
      </FileInput>
      <Button
        name={strings.certificateContainer.buttons.cancel}
        variant="secondary"
        secondaryClassName="popup_secondary"
        onClick={closeModal}
      />
    </ModalContainer>
  );
}

export default UploadCSR;
